import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { EventService } from "./ng1/services/Event";
import { RootState, LoadLeagueAction } from "@play/state";
import { Store } from "@ngrx/store";
import { IntializeAppAction } from "./app.action";

declare let Drupal: any;

@Component({
    template: "",
    selector: "app-root",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit {
    constructor(private store: Store<RootState>, private event: EventService) {}

    public ngOnInit(): void {
        this.store.dispatch(new IntializeAppAction());

        this.event.matchChange.subscribe(jsonData => {
            if (jsonData.event.league_id && +jsonData.event.league_id.$ === +Drupal.settings.leagueId) {
                this.store.dispatch(new LoadLeagueAction(jsonData.event.league_id.$, true));
            }
        });
    }
}
